import { Component, type ErrorInfo, type ReactNode } from "react";

interface Props {
  moduleId: string;
  fallback: (error: Error, reset: () => void) => ReactNode;
  onError?: (error: Error, info: ErrorInfo) => void;
  children: ReactNode;
}

interface State {
  error: Error | null;
}

/**
 * Isola falhas de RENDER de um módulo: um bug em um módulo não derruba o
 * shell nem os outros módulos (no CadFrn não havia error boundary algum).
 */
export class ModuleErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo): void {
    this.props.onError?.(error, info);
  }

  override componentDidUpdate(previous: Props): void {
    if (previous.moduleId !== this.props.moduleId && this.state.error) this.reset();
  }

  reset = () => this.setState({ error: null });

  override render() {
    return this.state.error
      ? this.props.fallback(this.state.error, this.reset)
      : this.props.children;
  }
}
